<template>
  <f7-page name="recharge-credits" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('RechargeCredits') }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-only href="/credits/transfer/">
          <f7-icon icon="f7-icons icon-transfer"></f7-icon>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block-title>{{ $t('Renewal') }}</f7-block-title>
    <f7-block>
      <p>{{ $t('RenewalDescription') }}</p>
    </f7-block>

    <f7-row no-gap class="max-width-560 margin-horizontal-auto">
      <f7-col v-for="(option, index) in rechargeOptions" :key="index" width="100" small="33">
        <div class="card elevation-6 elevation-hover-9 elevation-transition overflow-hidden margin">
          <div class="card-content card-content-padding text-align-center text-color-white" :class="option.bgColor">
            <p class="margin-bottom-half">{{ option.amount }} {{ $t('credits') }}</p>
            <div class="card-content-divider"></div>
            <p>{{ option.price }} {{ option.currency }}</p>
          </div>
          <div class="card-footer">
            <f7-link :href="option.url" external target="_blank" class="button button-fill color-green width-100" @click="openQuestionDialog">{{ $t('BuyNow') }}</f7-link>
          </div>
        </div>
      </f7-col>
    </f7-row>

  </f7-page>
</template>

<script>
import {mapGetters} from "vuex";
import { f7 } from 'framework7-vue';

export default {
  name: "recharge-credits",
  data(){

    return {
      rechargeOptions: []
    }
  },

  computed: {
    ...mapGetters(['MajorToken', 'MinorToken', 'TargetAsset']),
  },

  mounted() {
    this.rechargeOptions = [
      {
        amount: '1000',
        price: '$80.00',
        currency: 'USD',
        bgColor: 'bg-color-red',
        url: `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=EZZ22Z5F67K98&on0=KEY&os0=${ this.MinorToken }&on1=dn&os1=56&on2=other&os2=Agent-Controller-App`,
      },
      {
        amount: '500',
        price: '$45.00',
        currency: 'USD',
        bgColor: 'bg-color-green',
        url: `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=JSBWFD3AGHER2&on0=KEY&os0=${ this.MinorToken }&on1=dn&os1=56&on2=other&os2=Agent-Controller-App`,
      },
      {
        amount: '100',
        price: '$10.00',
        currency: 'USD',
        bgColor: 'bg-color-darkgray',
        url: `https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=UCC4Y44AJE76Y&on0=KEY&os0=${ this.MinorToken }&on1=dn&os1=56&on2=other&os2=Agent-Controller-App`,
      },
    ]
  },

  methods: {
    openQuestionDialog(){
      setTimeout(()=>{
        f7.dialog.confirm(this.$t('WasPaymentSuccessful'), async ()=>{
          let credits = await this.$store.dispatch('GetCreditBalance')
          f7.dialog.alert(this.$t('YourBalance', {c: credits}))
        })
      }, 5000)
    }
  }
}
</script>

<style scoped>

</style>